import { useContext, useEffect, useState } from "react";
import moment from "jalali-moment";
import { RemoveBackup, RestoreBackup } from "../api/api";
import SuccessToast from "./toasts/SuccessToast";
import ErrorToast from "./toasts/ErrorToast";
import ShareBackupModal from "./modals/ShareBackupModal";
import { Context } from "../context/Context";

const BackupsList = ({ backupsList, setBackupsList }) => {
  const { setIsLoading, authUser, setAuthUser } = useContext(Context);

  const [shareBackupModal, setShareBackupModal] = useState(null);
  const [shareBackupId, setShareBackupId] = useState(null);

  const handleShareBackupModal = (index) => {
    setShareBackupId(index);
    const modal = new window.bootstrap.Modal(shareBackupModal.current);
    modal.show();
  };

  const handleRemoveBackup = (index) => {
    setIsLoading(true);
    RemoveBackup({
      backup_id: index,
    }).then(({ data }) => {
      setBackupsList((prev) => prev.filter((_, i) => i !== index));
      SuccessToast(data.message);
      setIsLoading(false);
    });
  };

  const handleShareBackup = ({} = {}) => {};

  const handleRestoreBackup = (index) => {
    setIsLoading(true);
    RestoreBackup({
      index,
    })
      .then(({ data }) => {
        setIsLoading(false);
        SuccessToast(data.message);
        let updateAuthUser = { ...authUser };
        updateAuthUser.is_admin = data.user.is_admin == 1 ? 1 : 0;
        localStorage.setItem("user", JSON.stringify(updateAuthUser));
        window.location.href = "/";
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1500);
      })
      .catch(({ response }) => {
        return ErrorToast(response.data.message);
      });
  };

  const renderBackups = (backupsList) => {
    if (backupsList) {
      return backupsList.map((backup, index) => (
        <div className="card mb-1 col-12" key={index}>
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-start align-self-center">
              <div className="btn-group align-self-center ms-3">
                <button
                  type="button"
                  className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu">
                  <li onClick={(backup_id) => handleRestoreBackup(index)}>
                    <a className="dropdown-item">بازگردانی</a>
                  </li>
                  <li onClick={() => handleShareBackupModal(index)}>
                    <a className="dropdown-item">اشتراک</a>
                  </li>
                  <li onClick={() => handleRemoveBackup(index)}>
                    <a className="dropdown-item">حذف</a>
                  </li>
                </ul>
              </div>
              <div className="card-body py-0">
                <h5 className="card-title mb-3">{backup.split("_")[1]}</h5>
                {/* <p className="card-text">{backup.split("_")[0]}</p> */}
                <p className="card-text">
                  {moment(backup.split("_")[0], "YYYY-MM-DD", true).isValid()
                    ? moment(backup.split("_")[0], "YYYY-MM-DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")
                    : "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      ));
    }
  };

  return (
    <>
      <div
        className="backup-lists row mx-auto"
        style={{ width: "100%", maxWidth: "450px" }}
      >
        {renderBackups(backupsList)}
      </div>
      <ShareBackupModal
        setShareBackupModal={setShareBackupModal}
        backupId={shareBackupId}
      />
    </>
  );
};

export default BackupsList;
